import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.CopyToClipboard = class CopyToClipboard extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-copy-to-clipboard';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    setVars() {
        this.$btn = this.$element.find('.js-copy-btn');
        this.$string = this.$element.attr('data-string-to-copy');
        this.$input = this.$element.find('.js-copy-input');
    }

    setEventListeners() {
        this.$btn.on('click', this.onCopyButtonClick.bind(this));
    }

    onCopyButtonClick() {
        this.$input[0].value = this.$string;
        try {
            this.$input.select();
            document.execCommand('Copy');
            this.$btn.text('Copied to clipboard');
        } catch (err) {
            console.log("Can't copy to clipboard");
            alert(this.$string);
        }
    }
};



// WEBPACK FOOTER //
// ./components/copy-to-clipboard/scripts/copy-to-clipboard.js